// extracted by mini-css-extract-plugin
export var caretAnchor = "_wg-0";
export var dropdownContent = "_wg-1";